var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDeleted)?[_c('span',{staticClass:"label label-lg font-weight-bolder label-light-danger label-inline"},[_vm._v("Ngưng hoạt động")])]:[_c('span',{staticClass:"label label-lg font-weight-bolder label-light-success label-inline"},[_vm._v("Hoạt động")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }